import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

// Define the context type
interface ProjectSelectionContextType {
  selectedProjectId: number | null;
  setSelectedProjectId: (id: number | null) => void;
}

// Create the context with default values
const ProjectSelectionContext = createContext<ProjectSelectionContextType>({
  selectedProjectId: null,
  setSelectedProjectId: () => {},
});

// Custom hook to use the project selection context
export const useProjectSelection = () => useContext(ProjectSelectionContext);

// Provider component
export const ProjectSelectionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Initialize state from localStorage if available
  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(() => {
    const savedProject = localStorage.getItem('selectedProjectId');
    return savedProject ? Number(savedProject) : null;
  });

  // Save to localStorage whenever selectedProjectId changes
  useEffect(() => {
    if (selectedProjectId !== null) {
      localStorage.setItem('selectedProjectId', selectedProjectId.toString());
    }
  }, [selectedProjectId]);

  return (
    <ProjectSelectionContext.Provider value={{ selectedProjectId, setSelectedProjectId }}>
      {children}
    </ProjectSelectionContext.Provider>
  );
};
